import React from 'react';
import TemplatePage from "../template_page/template_page";
import DetailsPage from "../../luiss_components/c77_convenzioni_details/c77_convenzioni_details";

class AgreementPage extends TemplatePage {

    beforeRightComponentsList(page) {

        return (
            <DetailsPage data={page}></DetailsPage>
        )
    }
}

export default AgreementPage;
